import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    niandu: "", //年度
  },
  getters: {
    niandu: (state) => state.niandu,
  },
  mutations: {
    SET_NIANDU: (state, token) => {
      state.niandu = token;
    },
  },
  actions: {},
  modules: {},
});
